<template>
	<div>
		<div class="mian" v-loading="loading">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>{{info.category_id == 1?'工程专区':info.category_id == 2?'物资采购':info.category_id == 3?'答疑澄清修改':info.category_id == 4?'中标候选人公示':info.category_id == 5?'中标结果公示':'招标异常公告'}}</el-breadcrumb-item>
				<el-breadcrumb-item>详情</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="title">{{info.title}}</div>
			<div class="time fc">
				<div>发布时间：{{info.createtime}}</div>
				<!-- <div style="margin-left: 30px;">截至时间：{{info.endtime}}</div> -->
			</div>
			<div style="margin: 30px 0;">
				<div v-html="info.content"></div>
			</div>
			<div class="titles" v-if="info.files.length != 0">下载招标文件</div>
			<div class="itembox" v-if="info.files.length != 0">
				<div class="item" v-for="(item,index) in info.files" :key="index">
					<img src="../assets/wenjian.png" alt="">
					<div>{{item.title}}</div>
					<el-button type="danger" style="margin-top: 10px;" @click="downloads(item.file)">点击下载</el-button>
				</div>
			</div>
			<div class="titles" v-if="info.files.length != 0">上传投标文件</div>
			<div v-if="info.files.length != 0">
				<div class="inputbox fc">
					<div style="width: 120px;">联系人</div>
					<el-input v-model="contacts" placeholder="请输入联系人名称" style="width: 240px;"></el-input>
				</div>
				<div class="inputbox fc">
					<div style="width: 120px;">联系人手机号</div>
					<el-input v-model="phone" placeholder="请输入联系人手机号" style="width: 240px;"></el-input>
				</div>
			</div>
			<div class="fcc" style="margin-top: 20px;" v-if="info.files.length != 0">
				<el-upload class="upload-demo" action="http://zbpt.zjjljs.cn/api/common/upload" drag multiple
					accept="image/png,image/jpg,application/pdf,application/msword,application/vnd.ms-excel,text/plain"
					:on-success="handleAvatarSuccess">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">点击上传投标文件</div>
					<div class="el-upload__text" style="font-size: 10px;margin-top: 10px;">
						支持png/jpg/pdf/doc/xls/txt</div>
				</el-upload>
			</div>
			<div class="fcc" v-if="info.files.length != 0">
				<el-button type="primary" style="width: 160px;margin-top: 30px;" @click="determine"
					v-if="time < info.endtime">确定上传</el-button>
				<el-button type="danger" style="width: 160px;margin-top: 30px;" v-else>已截至</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				userinfo: null,
				time: '',
				info: {
					title: '',
					files: []
				},
				filelist: [],
				contacts: '', //联系人
				phone: '' //联系电话
			}
		},
		created() {
			this.timest();
			this.getinfo(this.$route.query.id);
			this.getuserinfo();
		},
		methods: {
			//获取投标详情信息
			getinfo(id) {
				this.loading = true;
				this.$api.home.noticeinfo({
					notice_id: id
				}).then(res => {
					if (res.code == 1) {
						this.info = res.data;
					}
					this.loading = false;
				})
			},
			//获取个人信息
			getuserinfo() {
				this.$api.home.userindex().then(res => {
					if (res.code == 1) {
						this.userinfo = res.data;
						console.log(this.userinfo.category_id)

					}
				})
			},
			//下载文件
			downloads(file) {
				window.open(file)
			},
			//投标
			determine() {
				let that = this;
				// if (that.info.category_id == 1 && this.userinfo.category_id == 5) {
				// 	//工程专区
				// 	alert('当前账号身份不符')
				// 	return;
				// }
				// if (that.info.category_id == 2 && this.userinfo.category_id != 5) {
				// 	//物资采购
				// 	alert('当前账号身份不符')
				// 	return;
				// }
				that.$confirm('确定上传吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let data = {
						notice_id: that.info.id,
						file: that.filelist.join(','),
						contacts: that.contacts,
						phone: that.phone
					}
					that.$api.home.noticesubmit(data).then(res => {
						if (res.code == 1) {
							that.$message({
								message: '恭喜你，上传成功',
								type: 'success'
							});
							setTimeout(() => {
								location.reload();
							}, 1500)
						}
					})
				}).catch(() => {});
			},
			//上传投标文件
			handleAvatarSuccess(e) {
				this.filelist.push(e.data.fullurl);
			},
			//获取当前时间戳
			timest() {
				var tmp = Date.parse(new Date()).toString();
				tmp = tmp.substr(0, 10);
				this.time = tmp;
				console.log(this.time);
			}
		}
	}
</script>

<style scoped>
	.mian {
		width: 1200px;
		margin: 50px auto;
	}

	.mian .title {
		width: 1000px;
		text-align: center;
		font-size: 36px;
		color: #333333;
		margin: 30px auto;
	}

	.mian .time {
		width: 1200px;
		height: 70px;
		font-size: 16px;
		color: #999999;
		border-bottom: #E5E5E5 solid 1px;
	}

	.mian .titles {
		font-size: 22px;
		border-left: #E11612 solid 6px;
		padding-left: 10px;
		margin: 30px 0;
	}

	.mian .itembox {
		display: flex;
		flex-wrap: wrap;
	}

	.mian .itembox .item {
		width: 200px;
		text-align: center;
	}

	.mian .itembox .item img {
		width: 110px;
		margin-bottom: 10px;
	}

	.mian .inputbox {
		width: 360px;
		margin: 0 auto;
		margin-top: 20px;
	}
</style>